import Alert from './Alert'

export default class Success extends Alert {
  constructor(title,text) {
    super('success',title,text)
  }
}